import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {object} props - Props.
 * @param props.children
 * @returns {JSX.Element} Component.
 */
export const StatsSectionResponsiveRowItems = ({ children }) => {
    return (
        <>
            {children && (
                <>
                    {React.Children.map(children, (child) => (
                        <>{React.cloneElement(child)}</>
                    ))}
                </>
            )}
        </>
    );
};

StatsSectionResponsiveRowItems.defaultProps = {
    name: 'StatsSectionResponsiveRowItems'
};

StatsSectionResponsiveRowItems.propTypes = {
    children: PropTypes.any.isRequired
};
